<template>
  <a href="#" class="store_box" @click.prevent="$emit('invite:friend')">
    <img src="/static/images/book.png"/>

    <div class="flex-column">
      <p class="title">{{ $_getTranslations.home_store_invite_item_games }}</p>

      <p class="desc">{{ $_getTranslations.home_store_invite_item_description }}</p>

      <div class="flex-row">
        <a href="#" @click.prevent>{{ $_getTranslations.home_store_invite_button }}</a>
      </div>
    </div>
  </a>
</template>

<script>
import translationMixin from '../../../../common/mixins/translation'

export default {
  name: 'InviteFriendListItem',
  emits: ['invite:friend'],
  mixins: [translationMixin]
}
</script>



// WEBPACK FOOTER //
// src/components/home/store/item/InviteFriendListItem.vue